import { loadSectionContent } from './product_page';

$(document).on('turbolinks:load', function() {
  if ($('#js-tab-content-ratings .js-pagyContainer').length) initializeRatingsPaginationHandler();
});

export function initializeRatingsPaginationHandler() {
  let $pagyLinks = $('.js-pagyContainer').find('.page-link');
  let $ratingsSection = $('#js-tab-content-ratings');

  $pagyLinks.each(function() {
    $(this).on('click', function(e) {
      e.preventDefault();
      let $this = $(this);
      let paginatedRatingsURL = $this.attr('href');

      if (!$this.parent().hasClass('active')) {
        loadSectionContent($ratingsSection, paginatedRatingsURL, true);
      }
    });
  });
}